import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, ReplaySubject, of, tap } from 'rxjs';
import { User } from 'app/core/user/user.types';
import { StorageService } from 'app/core/auth/storage.service';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);

    constructor(
        private _httpClient: HttpClient,
        private _storageService: StorageService
    ) {}

    // Setter & getter for user
    set user(value: User) {
        this._user.next(value);
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }

    /**
     * Get the current logged in user data (dari localStorage)
     */
    get(): Observable<User> {
        const userStr = localStorage.getItem('user');

        if (userStr) {
            try {
                // Decrypt and parse user data
                const decryptedStr = this._storageService.decryptionAES(userStr);
                const user: User = JSON.parse(decryptedStr);
                
                if (user) {
                    this._user.next(user);
                    return of(user);
                }
            } catch (e) {
                console.warn('UserService: Failed to decrypt/parse user from localStorage', e);
            }
        }

        // Return empty/null if failed - DO NOT return a default admin user as it hides permission issues
        return of(null);
    }

    /**
     * Update the user
     */
    update(user: User): Observable<any> {
        // Mock update
        this._user.next(user);
        return of(user);
        
        /*
        return this._httpClient.patch<User>('api/common/user', { user }).pipe(
            map((response) => {
                this._user.next(response);
                localStorage.setItem('user', JSON.stringify(response));
            })
        );
        */
    }
}
